<template>
  <v-layout align-start justify-center class="my-10" mx-0 row wrap>
    <v-flex xs2 sm2 md2 v-if="$vuetify.breakpoint.mdAndUp" id="panel">
      <v-card class="mr-3" tile>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="mb-4">
              <strong>Crédito PYME</strong>
            </div>
            <v-list-item-title class="mb-1">
              <p>
                <a
                  href="#hipotecario"
                  v-smooth-scroll="{
                    duration: 1000,
                    offset: -100,
                    container: '',
                    updateHistory: false,
                  }"
                  style="text-decoration: none; cursor: pointer;"
                  @click="panel = [0]"
                  >PYME HIPOTECARIO</a
                >
              </p>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-flex>
    <v-flex xs10 sm10 md10 id="expansion-pannel_right">
      <v-expansion-panels multiple mandatory v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header id="hipotecario">
            <h2>
              <strong>Crédito PYME HIPOTECARIO</strong>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout align-start justify-center row wrap>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="white--text my-12 text-uppercase">
                      {{ title1 }}
                    </h3>
                    <ul>
                      <li
                        class="white--text my-8 font-weight-bold"
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <hr />
                    <h3 class="white--text my-12 text-uppercase">
                      {{ title3 }}
                    </h3>
                    <ul>
                      <li
                        class="white--text my-8 font-weight-bold"
                        v-for="(item, index) in items3"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <hr />
                    <h3 class="white--text my-2 text-uppercase">
                      {{ title5 }}
                    </h3>
                    <ul>
                      <li
                        class="white--text my-4 font-weight-bold"
                        v-for="(item, index) in items5"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3
                      :class="[$vuetify.breakpoint.xl ? 'my-7' : 'my-11']"
                      class="primary_dark--text text-uppercase"
                    >
                      {{ title2 }}
                    </h3>
                    <ul>
                      <li
                        class="primary_dark--text my-8 font-weight-bold"
                        v-for="(item, index) in items2"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <hr />
                    <h3 class="primary_dark--text my-6 text-uppercase">
                      {{ title4 }}
                    </h3>
                    <ul>
                      <li
                        class="primary_dark--text my-4 font-weight-bold"
                        v-for="(item, index) in items4"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <div
                      class="justify-start my-4"
                      style="color: #1a5c96;font-size: 0.8rem;"
                    >
                      Todos los contratos de nuestros productos, se encuentran
                      debidamente registrados ante la CONDUSEF, en el RECA y
                      pueden ser consultados en las siguientes páginas
                      oficiales:<br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://www.gob.mx/condusef/"
                        target="_blank"
                        >https://www.gob.mx/condusef/</a
                      >
                      <br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://phpapps.condusef.gob.mx/reca/_index.php"
                        target="_blank"
                        >https://phpapps.condusef.gob.mx/reca/_index.php</a
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-dialog
        :fullscreen="$vuetify.breakpoint.smAndDown"
        v-model="dialog"
        persistent
        max-width="700px"
      >
        <v-card>
          <v-card-title class="pb-0">
            <v-container class="pb-0">
              <p class="primary--text">Pre-solicitud de Crédito</p>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Nombre completo *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Correo electronico *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Direccion del negocio * "></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Colonia *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Cuidad o localidad *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field label="Código postal *"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-text-field
                    v-mask="'(###)-###-####'"
                    label="Telefono con lada *"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-autocomplete
                    :items="[
                      'Abarrotes',
                      'Carniceria',
                      'Constructora',
                      'Consultorios médicos',
                      'Dulcerías',
                      'Electronica y Computo',
                      'Farmacias',
                      'Fotografia (estudio)',
                      'Fruterías',
                      'Hoteles y Moteles',
                      'Imprentas y editoriales',
                      'Joyeria y relojeria',
                      'Laboratorios clínicos',
                      'Librerias',
                      'Madererías',
                      'Marisquerías',
                      'Mueblería',
                      'Panaderias',
                      'Purificadora de agua',
                      'Refaccionaria',
                      'Restaurante',
                      'Rosticeria',
                      'Talleres',
                      'Telefonia',
                      'Tortillerias',
                      'Videoclub',
                      'Vinos y licores',
                      'Otro comercio o negocio',
                    ]"
                    label="Giro de su negocio * "
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
            <small>*indica el campo requerido</small>
          </v-card-text>
          <v-card-actions class="pr-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="default"
              text
              @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn
              class="font-weight-bold white--text"
              color="primary_dark"
              @click="dialog = false"
              >Enviar solicitud</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<style scoped></style>
<script>
import { mask } from "vue-the-mask";
export default {
  props: ["image"],
  directives: {
    mask,
  },
  mounted() {
    var el = document.getElementById("panel");
    var el2 = document.getElementById("expansion-pannel_right");
    var elTop =
      el.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top;

    window.addEventListener("scroll", function() {
      if (document.documentElement.scrollTop > elTop - 100) {
        el.style.position = "fixed";
        el.style.top = "115px";
        el.style.left = "0";
        el2.classList.add("offset-md-2");
      } else {
        el.style.position = "static";
        el.style.top = "auto";
        el.style.top = "auto";
        el.style.left = "auto";
        el2.classList.remove("offset-md-2");
      }
    });
  },
  data() {
    return {
      panel: [0],
      dialog: false,
      title1: "Requisitos para reestructura de crédito",
      title2: "Requisitos persona moral",
      title3: "Información de las Garantias",
      title4: "Información de Avales y Garantes",
      title5: "Condiciones Crediticias",
      title6: "Requisitos personas fisicas con ingresos vía nómina",
      title7: "Información de Avales",
      title8: "Beneficios",
      items: [
        {
          message: "Comprobante de domicilio (Luz, agua y teléfono).",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE Y CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP.",
        },
        {
          message:
            "Un aval (Identificación oficial, comprobante de domicilio y comprobante de ingresos).",
        },
        {
          message: "RFC Actualizada.",
        },
        {
          message: "Declaración anual (Últimos 2 años).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
      ],
      items2: [
        {
          message:
            "Acta constitutiva con hoja de inscripción en el registro público.",
        },
        {
          message: "Última acta de asamblea.",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message: "Un aval.",
        },
        {
          message: "Cédula de identificación fiscal actualizada.",
        },
        {
          message:
            "Copia simple de la constancia de la firma electrónica avanzada.",
        },
        {
          message: "Reporte de buró de crédito persona moral (condusef).",
        },
        {
          message: "Declaración anual (Último año).",
        },
        {
          message:
            "Representante legal (Poder notarial, identificación oficial y comprobante de domicilio).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
      ],
      //////////////////////////////////////////////
      items3: [
        {
          message: "Predial (Último año pagado).",
        },
        {
          message: "Copia de las escrituras.",
        },
        {
          message: "Certificado de libertad de gravamen.",
        },
        {
          message: "Avalúo de la propiedad en garantía.",
        },
        {
          message: "Certificado de número oficial.",
        },
      ],
      items4: [
        {
          message: "Identificación oficial vigente.",
        },
        {
          message: "Comprobante de domicilio (No mayor a 90 días).",
        },
        {
          message: "Comprobante de ingresos.",
        },
        {
          message: "Acta de nacimiento de aval o garante.",
        },
        {
          message: "Acta de matrimonio (Si aplica).",
        },
        {
          message:
            "Acta de nacimiento de cónyuge de aval y/o garante (Si aplica).",
        },
        {
          message:
            "Identificación oficial vigente de aval y/o garante (Si aplica).",
        },
      ],
      items5: [
        {
          message: "Pago mensual.",
        },
        {
          message: "Plazo de 12 a 48 meses.",
        },
        {
          message: "Tasa de interes desde el 18% anual mas IVA",
        },
        {
          message: "Comision por Apertura 4% mas iva",
        },
      ],
      items6: [
        {
          message: "Comprobante de domicilio (Luz, agua y teléfono).",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE Y CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP.",
        },
        {
          message:
            "Un aval (Identificación oficial, comprobante de domicilio y comprobante de ingresos).",
        },
        {
          message: "RFC Actualizada",
        },
        {
          message: "Declaración anual (Últimos 2 años).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
      ],
      items7: [
        {
          message:
            "Acta constitutiva con hoja de inscripción en el registro público.",
        },
        {
          message: "Última acta de asamblea.",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message: "Un aval.",
        },
        {
          message: "Cédula de identificación fiscal actualizada.",
        },
        {
          message:
            "Copia Simple de la Constancia de la firma electrónica avanzada.",
        },
        {
          message: "Reporte de buró de crédito persona moral (condusef).",
        },
        {
          message: "Declaración anual (Último año).",
        },
        {
          message:
            "Representante legal (Poder notarial, identificación oficial y comprobante de domicilio).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
      ],
      items8: [
        {
          message: "Factura original de la garantía con endoso a CAPITÁLICA.",
        },
        {
          message:
            "Seguro con cobertura amplia y beneficiario preferente a CAPITÁLICA (Si aplica).",
        },
        {
          message: "Avalúo de la garantía.",
        },
      ],
      items9: [
        {
          message: "Identificacion Oficial Vigente.",
        },
        {
          message: "Comprobante de domicilio (No mayor a 90 días).",
        },
        {
          message: "Comprobante de ingresos.",
        },
      ],
      items10: [
        {
          message: "Pago mensual.",
        },
        {
          message: "Plazo de 12 a 48 meses.",
        },
        {
          message: "Tasa de interes desde el 18% anual mas IVA",
        },
        {
          message: "Comision por Apertura 4% mas iva",
        },
      ],
      items11: [
        {
          message: "Comprobante de domicilio (Luz, agua y teléfono).",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE Y CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP.",
        },
        {
          message:
            "Un aval (Identificacion oficial, comprobante de domicilio y comprobante de ingresos).",
        },
        {
          message: "RFC Actualizada.",
        },
        {
          message: "Declaración anual (Últimos 2 años).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
      ],
      items12: [
        {
          message:
            "Acta constitutiva con hoja de inscripción en el registro público.",
        },
        {
          message: "Última acta de asamblea.",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message: "Cédula de identificación fiscal actualizada.",
        },
        {
          message:
            "Copia simple de la constancia de la firma electrónica avanzada.",
        },
        {
          message: "Reporte de Buró de crédito persona moral (condusef).",
        },
        {
          message: "Declaración anual (Último año).",
        },
        {
          message:
            "Representante legal (Poder notarial, identificación oficial y comprobante de domicilio).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
        {
          message: "2 referencias comerciales.",
        },
      ],
      items13: [
        {
          message: "Copia de las escrituras.",
        },
        {
          message: "Certificado de libertad de gravamen.",
        },
        {
          message: "Avalúo de la propiedad en garantia.",
        },
      ],
      items14: [
        {
          message: "Comprobante de domicilio (Luz, agua y teléfono).",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE Y CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP",
        },
        {
          message: "Últimos 4 recibos de nómina.",
        },
        {
          message:
            "Estados de cuenta bancarios de la nómina por los últimos 3 meses.",
        },
        {
          message: "2 referencias (Uno personal y uno familiar).",
        },
      ],
      items15: [
        {
          message: "Tasa Interes ordinario anual 16.32% mas iva",
        },
        {
          message: "Comision por Apertura 2% mas iva",
        },
        {
          message: "Plazo hasta 96 meses.",
        },
        {
          message: "Financiamiento hasta el 90% del valor del terreno.",
        },
        {
          message: "Seguro Deudor 1%.",
        },
      ],
      items16: [
        {
          message: "Comprobante de domicilio (Luz, agua y teléfono).",
        },
        {
          message:
            "Comprobante de domicilio del negocio (Luz, agua y teléfono).",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE Y CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP.",
        },
        {
          message: "Cedulo de identificacion fiscal actulizada",
        },
        {
          message: "Declaración anual (Últimos 2 años).",
        },
        {
          message: "Estados de cuenta bancarios (Últimos 3 meses).",
        },
        {
          message: "Estados financieros (Últimos 2 años).",
        },
        {
          message: "2 referencias (Uno comercial y uno personal o  familiar).",
        },
      ],
      items17: [
        {
          message: "Pagos programados",
        },
        {
          message: "Financiamiento de escrituras (opcional).",
        },
      ],
    };
  },
};
</script>
